import { Routes } from '@angular/router';
import { MsalRedirectComponent, MsalGuard } from '@azure/msal-angular';
import { canActivateRoute } from './core/can-activate-route';
import { canActivateConfigureRoute } from './core/can-activate-configure-route';
import { canActivateWorkflowsRoute } from './core/can-activate-workflows-route';

export const APP_ROUTES: Routes = [
    {
        // Needed for handling redirect after login
        path: 'auth',
        component: MsalRedirectComponent
    },
    {
        path: '',
        pathMatch: 'full',
        canActivate: [MsalGuard, canActivateWorkflowsRoute],
        loadComponent: () => import('./home/workflows-view/workflows-view.component').then(c => c.WorkflowsViewComponent),
    },
    {
        path: 'search-map',
        canActivate: [MsalGuard, canActivateRoute],
        loadComponent: () => import('./home/search-map-view/search-map-view.component').then(c => c.SearchMapViewComponent),
    },
    {
        path: 'search-list',
        canActivate: [MsalGuard, canActivateRoute],
        loadComponent: () => import('./home/search-list-view/search-list-view.component').then(c => c.SearchListViewComponent),
    },
    {
        path: 'projects',
        canActivate: [MsalGuard, canActivateRoute],
        loadComponent: () => import('./home/redirect-view/redirect-view.component').then(c => c.RedirectViewComponent),
    },
    {
        path: 'configure',
        canActivate: [MsalGuard, canActivateConfigureRoute],
        loadChildren: () => import('./configure/configure.routes').then(r => r.configureRoutes),
    },
    {
        path: 'inspect',
        canActivate: [MsalGuard, canActivateRoute],
        loadChildren: () => import('./inspect/inspect.routes').then(r => r.inspectRoutes),
    },
    {
        path: 'validate/ppo-toggle-plan/:id',
        canActivate: [MsalGuard, canActivateRoute],
        loadChildren: () => import('./validate/validate.routes').then(r => r.loadModelsViewRoutes),
    },
    {
        path: 'export',
        canActivate: [MsalGuard, canActivateRoute],
        loadChildren: () => import('./export/export.routes').then(r => r.exportRoutes),
    },
    {
        path: 'error/no-access',
        loadComponent: () => import('./error-views/no-access-view/no-access-view.component').then(c => c.NoAccessViewComponent),
    },
    {
        path: 'error/access-denied',
        loadComponent: () => import('./error-views/access-denied/access-denied.component').then(c => c.AccessDeniedComponent),
    },
    {
        path: 'error/404',
        loadComponent: () => import('./error-views/page404-view/page404-view.component').then(c => c.Page404ViewComponent),
    },
    {
        path: 'error/500',
        loadComponent: () => import('./error-views/page500-view/page500-view.component').then(c => c.Page500ViewComponent),
    },
    {
        path: 'error/unknown',
        loadComponent: () => import('./error-views/unknown-view/unknown-view.component').then(c => c.UnknownViewComponent),
    },
    {
        path: 'error/not-vestas-network',
        loadComponent: () => import('./error-views/not-vestas-network-view/not-vestas-network-view.component').then(c => c.NotVestasNetworkViewComponent),
    },
    {
        path: '**',
        loadComponent: () => import('./error-views/page404-view/page404-view.component').then(c => c.Page404ViewComponent),
    },
];
